import { JsonObject, JsonProperty } from 'json2typescript';
import { SlotTestResultItem } from '../slot-test-result-item.model';

@JsonObject('SlotTestResponse')
export class SlotTestResponse {

  @JsonProperty('jackpot_value', Number)
  jackpotValue: number = 0;

  @JsonProperty('reward', Number)
  reward: number = 0;

  @JsonProperty('cost', Number)
  cost: number = 0;

  @JsonProperty('balance', Number)
  balance: number = 0;

  @JsonProperty('results', [SlotTestResultItem])
  results: SlotTestResultItem[] = [];
}
